import React, { useState } from 'react';
import { FileText, Loader2, Undo2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

export const Vorvertraglich = ({ rows, info, checked, onChange }) => (
  <div className="mb-5" data-testid="raten-vorvertraglich">
    <details className="border border-gray-200 rounded-sm" open>
      <summary className="cursor-pointer px-4 py-3 text-xs tracking-[0.15em] uppercase text-[#1B3A5C] font-semibold">Vorvertragliche Informationen (Europäische Standardinformationen für Verbraucherkredite)</summary>
      <table className="w-full text-xs"><tbody>
        {(rows || []).map(([k, v]) => <tr key={k} className="border-t border-gray-100"><td className="px-4 py-1.5 text-[#7a8a99] w-[38%] align-top">{k}</td><td className="px-4 py-1.5 text-[#1B3A5C]">{v}</td></tr>)}
      </tbody></table>
      <div className="px-4 py-3 border-t border-gray-100 text-[11px] text-[#34536b] space-y-2" data-testid="raten-widerrufsinfo">
        <p className="font-semibold text-[#1B3A5C]">Widerrufsinformation</p>
        {(info || []).map(([k, v], i) => <p key={i}>{k && <b>{k}: </b>}{v}</p>)}
        <p className="text-[#7a8a99]">Der rechtlich maßgebliche Text ist deutsch.</p>
      </div>
    </details>
    <label className="mt-3 flex items-start gap-3 text-xs text-[#34536b] cursor-pointer">
      <input type="checkbox" className="mt-0.5 w-4 h-4 accent-[#b8893d] flex-shrink-0" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid="raten-pay-vorvertraglich" />
      <span>Ich habe die vorvertraglichen Informationen und die Widerrufsinformation erhalten und gelesen.</span>
    </label>
  </div>
);

const oeffnen = async (planId, nr) => {
  const r = await api.get(`/raten/${planId}/schreiben/${nr}.pdf`, { responseType: 'blob' });
  window.open(URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })), '_blank');
};

export const RatenWiderruf = ({ p, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const fristOffen = ['aktiv', 'ueberfaellig'].includes(p.status) && p.widerruf_frist_bis && new Date(p.widerruf_frist_bis) > new Date();
  const widerrufen = async () => {
    if (!window.confirm('Möchten Sie die Ratenzahlungsvereinbarung wirklich widerrufen? Der offene Betrag ist dann innerhalb von 30 Tagen in einer Summe zu zahlen.')) return;
    setBusy(true); setErr('');
    try { await api.post(`/raten/${p.plan_id}/widerrufen`); onChanged(); } catch (e) { setErr(e?.response?.data?.detail || 'Widerruf fehlgeschlagen'); }
    setBusy(false);
  };
  if (!p.schreiben?.length && !fristOffen && !['widerrufen', 'widerruf_bestaetigt'].includes(p.status)) return null;
  return (
    <div className="mb-3 text-xs space-y-2" data-testid={`raten-widerruf-${p.plan_id}`}>
      {(p.schreiben || []).map((s) => (
        <button key={s.nr} type="button" onClick={() => oeffnen(p.plan_id, s.nr)} className="flex items-center gap-1.5 text-[#1B3A5C] hover:text-[#b8893d] underline underline-offset-2" data-testid={`raten-schreiben-${p.plan_id}-${s.nr}`}>
          <FileText className="w-3.5 h-3.5" /> {s.titel} ({new Date(s.am).toLocaleDateString('de-DE')})
        </button>
      ))}
      {fristOffen && (
        <div className="p-3 bg-[#fbf7f0] border border-[#e5d8b8] rounded-sm">
          <p className="text-[#1B3A5C]">Widerrufsfrist bis <b>{new Date(p.widerruf_frist_bis).toLocaleDateString('de-DE')}</b>. Die Widerrufsinformation finden Sie in Schreiben 1.</p>
          <button type="button" onClick={widerrufen} disabled={busy} className="mt-2 inline-flex items-center gap-1.5 h-8 px-3 rounded-[10px] border border-rose-300 text-rose-700 hover:bg-rose-50" data-testid={`raten-widerrufen-${p.plan_id}`}>
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Undo2 className="w-3.5 h-3.5" />} Ratenzahlung widerrufen
          </button>
          {err && <p className="mt-1 text-rose-700">{err}</p>}
        </div>
      )}
      {p.status === 'widerrufen' && <p className="text-rose-700" data-testid={`raten-widerrufen-hinweis-${p.plan_id}`}>Widerruf eingegangen am {new Date(p.widerruf_am).toLocaleDateString('de-DE')} – die Kanzlei bestätigt den Eingang.</p>}
      {p.status === 'widerruf_bestaetigt' && <p className="text-[#34536b]">Widerruf bestätigt. Die Lastschriften wurden gestoppt.</p>}
    </div>
  );
};
